const sessionId = Date.now()
    .toString()
    .concat('.', Math.random() * 10000 + 1);

export default sessionId;
